// New API envelope adapter. Keep legacy transport behavior opt-in at the caller.
export function apiError(response, fallback = 'Request failed') {
  const payload = response && response.data
  const message = payload && typeof payload === 'object'
    ? (typeof payload.msg === 'string' && payload.msg) || (typeof payload.message === 'string' && payload.message)
    : ''
  const error = new Error(message || fallback)
  error.response = response
  error.status = response && response.status
  error.code = payload && payload.code
  // Existing pages use both error.msg and error.data.msg.
  error.msg = error.message
  error.data = { code: error.code, msg: error.message }
  return error
}

export function unwrapApiResponse(response) {
  const payload = response && response.data
  if (response && response.status >= 200 && response.status < 300
      && payload && typeof payload === 'object' && payload.code === 1) return payload
  throw apiError(response, 'Invalid API response')
}

export function removeLegacyCredentials(headers) {
  if (!headers) return
  for (const name of Object.keys(headers)) {
    if (['token', 'x-session-key', 'authorization'].includes(name.toLowerCase())) {
      delete headers[name]
    }
  }
}
